import { DynamicMetaTags } from "../utils/dynamicMetaTags";
import "./LifetimeEminentLeadershipAward.css";

const pageTitle =
  "Nahil Wijesuriya Receives CPM Sri Lanka Lifetime Leadership Award";
const pageDescription =
  "Engineer Nahil Wijesuriya is recognised with CPM Sri Lanka's Lifetime Eminent Leadership Award after a pioneering business career and more than USD 18 million in publicly known giving.";
const pageUrl = "nahil.lk/lifetime-eminent-leadership-award-cpm-sri-lanka/";
const featuredImage =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_with_awards.jpg";
const presentationVideo =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/presentation_about_nahil.mp4";
const presentationThumbnail =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/thumbnail_nahil_wijesuriya.jpg";
const awardCeremonyVideo =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/landscape_nahil_wijesuriya_recieving_award.mp4";
const awardCeremonyThumbnail =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/thumbnail_nahil_recieving_award.jpg";
const celebrationVideo =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_having_fun_taking_pictures_with_award.mp4";
const celebrationThumbnail =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/thumbnail_nahil_having_fun.jpg";
const afterAwardVideo =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/sitting_down_with_nahil_after_award.mp4";
const afterAwardThumbnail =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/thumbanil_nahil_after_receiving_award.jpg";
const collageImages = [
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_tereza_viji.JPG",
    alt: "Nahil Wijesuriya with Tereza and Viji at the CPM Sri Lanka awards",
  },
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_mano_viji_tereza.JPG",
    alt: "Nahil Wijesuriya with Mano, Viji and Tereza at the awards ceremony",
  },
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_awards.JPG",
    alt: "Nahil Wijesuriya with his Lifetime Eminent Leadership Award",
  },
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/viji_nahil.JPG",
    alt: "Viji and Nahil Wijesuriya at the CPM Sri Lanka awards",
  },
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/nahil_and_friends.jpeg",
    alt: "Nahil Wijesuriya celebrating with friends after receiving the award",
  },
  {
    src: "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/81-lifetime-eminent-leadership-award-CPM-sri-lanka/online/congradulation_from_one_of_members.jpeg",
    alt: "Nahil Wijesuriya receiving congratulations from a CPM Sri Lanka member",
  },
];

export const LifetimeEminentLeadershipAward = () => {
  return (
    <>
      <DynamicMetaTags
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        ogImage={featuredImage}
        ogUrl={pageUrl}
        ogType="article"
        publishedTime="2026-09-15T00:00:00+05:30"
      />
      <main className="award-page">
        <article className="award-article">
          <header className="award-hero">
            <div className="award-hero-copy">
              <p className="award-kicker">Leadership · Recognition · 2026</p>
              <h1>
                Nahil Wijesuriya Selected for CPM Sri Lanka Lifetime Eminent
                Leadership Award
              </h1>
              <p className="award-intro">
                Engineer Nahil Wijesuriya, FIMarEST, has been selected to
                receive the <strong>Lifetime Eminent Leadership Award</strong>
                at the{" "}
                <strong>
                  CPM Sri Lanka Management Leadership Excellence Awards 2026
                </strong>
                , recognising a career that spans marine engineering, shipping,
                technology, media, property development, hospitality and
                philanthropy.
              </p>
              <time className="award-date" dateTime="2026-09-15">
                15 September 2026
              </time>
            </div>
            <figure className="award-portrait">
              <img
                src={featuredImage}
                alt="Nahil Wijesuriya receiving the Lifetime Eminent Leadership Award at the CPM Sri Lanka Management Leadership Excellence Awards 2026"
              />
              <figcaption>
                Lifetime Eminent Leadership Award · CPM Sri Lanka
              </figcaption>
            </figure>
          </header>

          <div className="award-body">
            <p className="award-lede">
              From building East West Enterprises into a diversified Sri Lankan
              business group to committing more than{" "}
              <strong>Rs. 6.1 billion (approximately USD 18.7 million)</strong>{" "}
              in publicly known giving, Nahil Wijesuriya&apos;s record combines
              enterprise with direct, measurable investment in Sri Lanka&apos;s
              future.
            </p>
            <p>
              The award was conferred by the Governing Council of the Institute
              of Chartered Professional Managers of Sri Lanka. It recognises
              both the businesses and industries he helped shape over nearly
              five decades and the major education, healthcare and community
              projects he has supported in recent years.
            </p>

            <figure className="award-video">
              <video
                controls
                playsInline
                poster={presentationThumbnail}
                preload="metadata"
                title="Presentation about Nahil Wijesuriya and his contributions"
              >
                <source src={presentationVideo} type="video/mp4" />
                Your browser does not support the video element.
              </video>
              <figcaption>
                A presentation on Nahil Wijesuriya and his contributions to
                business, education and society.
              </figcaption>
            </figure>

            <section>
              <p className="award-section-number">01</p>
              <h2>From marine engineer to industry pioneer</h2>
              <p>
                A Class 1 qualified marine engineer, Nahil Wijesuriya founded
                East West Enterprises in 1977 and expanded it across shipping,
                freight, technology, media, property and hospitality. The group
                established Sri Lanka&apos;s first off-port container freight
                station and operated what was then the country&apos;s largest
                customs clearing-house agency.
              </p>
              <p>
                His maritime ventures included salvage and towage vessels,
                offshore supply vessels and the 37,000-deadweight-tonne
                <em> MT Bunker 1</em>. Beyond shipping, he secured Sri
                Lanka&apos;s first IBM PC dealership through East West
                Information Systems and pioneered the country&apos;s first
                24-hour television channels, ETV 1 and ETV 2.
              </p>
              <p>
                His investments later extended to the Ceylon Continental Hotel,
                now The Kingsbury, and the development of the 200-room Weligama
                Bay Marriott Resort &amp; Spa. These ventures reflect the
                award&apos;s emphasis on leaders who turned technical knowledge
                and calculated risk into institutions with lasting national
                value.
              </p>
            </section>

            <aside className="award-pullquote">
              <p>
                More than USD 18 million directed towards classrooms,
                scholarships, children&apos;s healthcare and community
                facilities.
              </p>
            </aside>

            <section>
              <p className="award-section-number">02</p>
              <h2>A legacy of giving</h2>
              <p>
                His publicly known contributions now exceed Rs. 6.1 billion,
                approximately USD 18.7 million. The largest is the{" "}
                <strong>Rs. 3 billion Trinity College Endowment Fund</strong>,
                established in 2026 to provide scholarships, financial
                assistance and long-term support for educational excellence.
              </p>
              <p>
                Major recent commitments also include{" "}
                <strong>Rs. 1 billion for the Little Hearts Project</strong> at
                Lady Ridgeway Hospital,
                <strong>
                  {" "}
                  Rs. 600 million for the S. Thomas&apos; College IT Complex
                </strong>
                , Rs. 400 million for the Sunera Foundation and Rs. 250 million
                for Ananda College&apos;s STEAM Centre of Excellence.
              </p>
              <p>
                The record also includes the Rs. 270 million Roshanne Wijesuriya
                Building at Bishop&apos;s College, Rs. 161 million in equipment
                for the National Kidney Stone Referral Centre, and Rs. 100
                million each for the Nalanda Sports Arena and Trinity&apos;s
                badminton complex. Since 2017, the Agnes Wijesuriya Charity
                Foundation has also funded monthly scholarships for 54
                low-income naval engineering students.
              </p>
            </section>

            <section>
              <p className="award-section-number">03</p>
              <h2>
                CPM Sri Lanka Management Leadership Excellence Awards 2026
              </h2>
              <p>
                The award formed part of the{" "}
                <strong>
                  CPM Sri Lanka Management Leadership Excellence Awards 2026
                </strong>
                , held on 15 September 2026 at the Monarch Imperial Hotel in Sri
                Jayewardenepura Kotte.
              </p>
              <p>
                The annual event recognises leadership excellence across Sri
                Lanka&apos;s corporate and public sectors. The 2026 ceremony
                brought together approximately 500 senior corporate leaders and
                recognised around 125 C-suite executives, decision-makers and
                management professionals.
              </p>
              <p>
                The wider awards programme evaluates applicants through a
                structured judging process across leadership, industry and
                management categories. The Lifetime Eminent Leadership Award is
                a special distinction conferred by CPM Sri Lanka&apos;s
                Governing Council.
              </p>
              <figure className="award-video">
                <video
                  controls
                  playsInline
                  poster={awardCeremonyThumbnail}
                  preload="metadata"
                  title="Nahil Wijesuriya receiving the Lifetime Eminent Leadership Award"
                >
                  <source src={awardCeremonyVideo} type="video/mp4" />
                  Your browser does not support the video element.
                </video>
                <figcaption>
                  Nahil Wijesuriya receiving the Lifetime Eminent Leadership
                  Award at the CPM Sri Lanka Management Leadership Excellence
                  Awards 2026.
                </figcaption>
              </figure>
            </section>

            <section
              className="award-collage"
              aria-labelledby="award-collage-title"
            >
              <div className="award-collage-heading">
                <p className="award-section-number">Gallery</p>
                <h2 id="award-collage-title">Celebrating the moment</h2>
              </div>
              <div className="award-collage-grid">
                <figure className="award-collage-video">
                  <video
                    controls
                    playsInline
                    poster={celebrationThumbnail}
                    preload="metadata"
                    title="Nahil Wijesuriya taking photographs with his award"
                  >
                    <source src={celebrationVideo} type="video/mp4" />
                    Your browser does not support the video element.
                  </video>
                </figure>
                <figure className="award-collage-video">
                  <video
                    controls
                    playsInline
                    poster={afterAwardThumbnail}
                    preload="metadata"
                    title="Sitting down with Nahil Wijesuriya after the award ceremony"
                  >
                    <source src={afterAwardVideo} type="video/mp4" />
                    Your browser does not support the video element.
                  </video>
                </figure>
                {collageImages.map((image, index) => (
                  <figure
                    className={`award-collage-image award-collage-image-${index + 1}`}
                    key={image.src}
                  >
                    <img src={image.src} alt={image.alt} loading="lazy" />
                  </figure>
                ))}
              </div>
            </section>

            <section>
              <p className="award-section-number">04</p>
              <h2>About CPM Sri Lanka</h2>
              <p>
                The{" "}
                <a
                  href="https://cpmsrilanka.org/about-us"
                  target="_blank"
                  rel="noreferrer"
                >
                  Institute of Chartered Professional Managers of Sri Lanka
                </a>{" "}
                is a professional body representing managers and executives.
              </p>
              <p>
                The Institute was established with the assistance of the All
                India Management Association and CMA Sri Lanka. It provides
                professional membership at Associate, Member and Fellow levels
                while supporting the development of management professionals
                through education, research, conferences, professional
                development programmes and knowledge-sharing events.
              </p>
              <p>
                CPM Sri Lanka is also an active member of the Association of
                Management Development Institutions in South Asia and works with
                professional organisations in Sri Lanka and internationally to
                promote higher standards of management, governance, ethics and
                innovation.
              </p>
              <p>
                The{" "}
                <a
                  href="https://www.cpmsrilanka.org/networking-details/CPM-Sri-Lanka-Management-Leadership-Excellence-Awards-2026/262"
                  target="_blank"
                  rel="noreferrer"
                >
                  Management Leadership Excellence Awards
                </a>{" "}
                form part of the Institute&apos;s work to recognise individuals
                whose leadership creates meaningful organisational and national
                impact.
              </p>
            </section>

            <section>
              <p className="award-section-number">05</p>
              <h2>Why this recognition matters</h2>
              <p>
                The Lifetime Eminent Leadership Award brings two parts of Nahil
                Wijesuriya&apos;s life into a single record: an engineering-led
                business career that opened new ground in shipping, technology
                and media, and a philanthropic programme now benefiting at least
                14 major institutions across Sri Lanka.
              </p>
              <p>
                Its clearest legacy is practical: better-equipped hospitals, new
                classrooms and technology centres, permanent school endowments,
                sports facilities and scholarships that give young Sri Lankans
                opportunities extending far beyond the award itself.
              </p>
            </section>
          </div>
        </article>
      </main>
    </>
  );
};
